import { useRef, useEffect, useCallback } from 'react';
import { Box } from 'components/ui';
import styled from 'styled-components/macro'
import { observeWindowResize } from 'utils';
import { FUTURA_PALETTES, AUDIO_OPTIONS } from '../constants';

const Wrapper = styled(Box)`
  overflow: hidden;
  margin: 0 auto;
  display: flex;
  position: relative;
`;
interface FuturaVisualizationProps {
  elementId: string;
  width?: string | number;
  height?: string | number;
  pieceData: any;
  twists: number;
  distortion: boolean;
  paletteName: string;
  noteShape: 'Square' | 'Line' | 'Triangle';
  onTogglePlay?: () => void;
}

let moved;
const FuturaVisualization = ({
  elementId,
  width = 480,
  height = 480,
  twists,
  distortion,
  noteShape,
  pieceData,
  paletteName,
  onTogglePlay,
}: FuturaVisualizationProps) => {
  const EBF = (window as Window).EulerBeatsFutura;
  const palette = FUTURA_PALETTES.find(palette => palette.name === paletteName)
  const renderEl = useRef(null)
  
  useEffect(() => {
    const element = document.getElementById(elementId);
    if (element) {
      const visualOptions = {
        stats: false,
        palette,
        twists,
        distortion,
        noteShape,
      };
      
      console.table(pieceData.piece.traits);
      console.table(pieceData.piece.stats());

      EBF.visual.render(element, pieceData, visualOptions, AUDIO_OPTIONS);
    } else {
      console.error('Element not found')
    }

    return () => {
      EBF.audio.stop();
      EBF.visual.stop(elementId);
    }
  }, [
    renderEl,
    EBF.visual,
    EBF.audio,
    distortion,
    elementId,
    noteShape,
    palette,
    pieceData,
    twists,
  ]);

  observeWindowResize(() => {
    EBF.visual.resize(elementId);
  });  

  const togglePlay = useCallback(() => {
    EBF.visual.toggle(elementId);
    onTogglePlay && onTogglePlay();
  }, [EBF, elementId, onTogglePlay]);

  const onMouseDown = useCallback(() => {
    moved = false;
  }, []);
  
  const onMouseMove = useCallback(() => {
    moved = true;
  }, []);
  
  const onMouseUp = useCallback(() => {
    if (!moved) {
      togglePlay();
    }
  }, [togglePlay]);

  return (
    <Wrapper width={width} height={height} background="black">
      <div
        id={elementId}
        ref={renderEl}
        onMouseDown={onMouseDown}
        onMouseMove={onMouseMove}
        onMouseUp={onMouseUp}
        style={{
          width: '100%',
          height: '100%',
        }}
      />
    </Wrapper>
  );
};

export default FuturaVisualization;
